var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-choose"},[_c('router-link',{attrs:{"to":{ name: '銷售管理系統' }}},[_vm._v("銷售管理系統")]),_c('router-link',{attrs:{"to":{ name: '學員報到系統' }}},[_vm._v("學員報到系統")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }